import React from 'react'
import '../Style/Suggested_Product.css'

function Suggested_Products() {
    return (
        <>
            <div className='suggested-products'>
                <div className='title'>محصولات پیشنهادی</div>
                <div className='list'>
                    <div className='slider'>
                        <div className='product'>
                            <div className='product-image' style={{ backgroundImage: `url(${require("../Product_Images/1426030.jpg")})` }}></div>
                            <div className='product-title'>پریز برق</div>
                            <div className='price'>
                                <i class="icony icony-toman price-icon"></i>
                                <div className='normal-text'>50,000</div>
                            </div>
                        </div>
                        <div className='product'>
                            <div className='product-image' style={{ backgroundImage: `url(${require("../Product_Images/1b3d620e25ecfeccfe946d335e499386125f10aa.jpeg")})` }}></div>
                            <div className='product-title'>باند maxeeder</div>
                            <div className='price'>
                                <i class="icony icony-toman price-icon"></i>
                                <div className='normal-text'>1,000,000</div>
                            </div>
                        </div>
                        <div className='product'>
                            <div className='product-image' style={{ backgroundImage: `url(${require("../Product_Images/1694.jpg")})` }}></div>
                            <div className='product-title'>سه راهی برق</div>
                            <div className='price'>
                                <i class="icony icony-toman price-icon"></i>
                                <div className='normal-text'>12,000</div>
                            </div>
                        </div>
                        <div className='product'>
                            <div className='product-image' style={{ backgroundImage: `url(${require("../Product_Images/2.jpg")})` }}></div>
                            <div className='product-title'>ریموت درب کرکره ای</div>
                            <div className='price'>
                                <i class="icony icony-toman price-icon"></i>
                                <div className='normal-text'>29,000</div>
                            </div>
                        </div>
                        <div className='product'>
                            <div className='product-image' style={{ backgroundImage: `url(${require("../Product_Images/904db77cea07619877a4ee9f26a0fba96215615d_1602397201.jpg")})` }}></div>
                            <div className='product-title'>رادیو</div>
                            <div className='price'>
                                <i class="icony icony-toman price-icon"></i>
                                <div className='normal-text'>70,000</div>
                            </div>
                        </div>
                        <div className='product'>
                            <div className='product-image' style={{ backgroundImage: `url(${require("../Product_Images/516823.jpg")})` }}></div>
                            <div className='product-title'>رادیو</div>
                            <div className='price'>
                                <i class="icony icony-toman price-icon"></i>
                                <div className='normal-text'>70,000</div>
                            </div>
                        </div>
                        <div className='product'>
                            <div className='product-image' style={{ backgroundImage: `url(${require("../Product_Images/هواکش-صنعتی-دمنده-30-سانت-1400-دور-مدل-ایلکای-هفت-پر-با-قاب-vik-30l4s.jpg")})` }}></div>
                            <div className='product-title'>رادیو</div>
                            <div className='price'>
                                <i class="icony icony-toman price-icon"></i>
                                <div className='normal-text'>70,000</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Suggested_Products